import { render, staticRenderFns } from "./InitData.vue?vue&type=template&id=ac20293e&"
import script from "./InitData.vue?vue&type=script&lang=js&"
export * from "./InitData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports